import { cn } from '@/lib/utils'

export const hasLinkedRaidPlanRefs = (
  activity: Pick<wowaudit.EventActivity, 'linkedPlans'>,
) => (activity.linkedPlans ?? []).some((entry) => entry.type === 'raid')

export const linkedPlanRevealClassName = (isPending: boolean) =>
  cn(
    'transition-opacity duration-300',
    isPending && 'opacity-0 pointer-events-none',
  )
